<template>
  <div class="h-full w-full bg-gray-100 p-4">
    <PageSection title="">
      <template #sub-header>
        <BaseButton
          v-if="editMode"
          :title="$t('global.add_unavailability_item')"
          secondary-color
          icon="plus"
          size="extra-small"
          :disabled="cannotAddNewItem"
          @click="addNewItem"
        />
      </template>

      <template #default>
        <div class="flex w-full flex-col gap-3">
          <AvailabilityItemCard
            v-for="(item, idx) in availabilityItems"
            :key="item.id || item.count"
            v-model:item="availabilityItems[idx]"
            @refresh-list="fetchUnavailabilityItems"
            @delete-item="(id) => deletedItem(id)"
          />
        </div>
      </template>
    </PageSection>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import PageSection from '@c/PageSection.vue'
import AvailabilityItemCard from '@/views/settings/unavailability-item/components/AvailabilityItemCard.vue'

let newAvailabilityItem = Object.freeze({
  id: null,
  model_id: null,
  start_at: null,
  end_at: null,
  reason: null,
  remarks: null
})

export default {
  name: 'AvailabilityItemsManagement',
  components: { AvailabilityItemCard, PageSection, BaseButton },
  props: {
    id: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },
  emits: [],
  data() {
    return {
      availabilityItems: []
    }
  },
  computed: {
    cannotAddNewItem() {
      return this.availabilityItems.length && !this.availabilityItems.at(0).id
    }
  },
  watch: {
    editMode(newValue) {
      if (!newValue && !this.availabilityItems[0]?.id) {
        this.availabilityItems.splice(0, 1)
      }
    }
  },
  mounted() {
    this.fetchUnavailabilityItems()
  },
  methods: {
    ...mapActions({
      processFetchUnavailabilityItemsAction:
        'unavailability/fetchUnavailabilityItems',
      processDeleteUnavailabilityItemsAction:
        'unavailability/deleteUnavailabilityItems',
      processUndoDeleteUnavailabilityItemsAction:
        'unavailability/undoDeleteUnavailabilityItems'
    }),
    fetchUnavailabilityItems() {
      this.processFetchUnavailabilityItemsAction({
        id: this.id,
        target: this.target
      }).then((response) => {
        this.availabilityItems = response.list
      })
    },
    addNewItem() {
      let newItem = { ...newAvailabilityItem }
      if (this.target === 'user') {
        newItem = {
          ...newItem,
          model_type: 'App\\Models\\User',
          model_id: this.id
        }
      } else if (this.target === 'resource') {
        newItem = {
          ...newItem,
          model_type: 'App\\Models\\MaterialResource',
          model_id: this.id
        }
      }
      this.availabilityItems.push(newItem)
    },
    deletedItem(availability_id) {
      this.processDeleteUnavailabilityItemsAction({
        id: availability_id
      }).then((response) => {
        this.fetchUnavailabilityItems()
        this.$h.toastAction('delete', this.$t('toasts.deleted'), null, [
          {
            title: this.$t('button.cancel'),
            class: 'text-red-700',
            action: () => {
              this.undoDelete(availability_id)
            }
          }
        ])
      })
    },
    undoDelete(availability_id) {
      this.processUndoDeleteUnavailabilityItemsAction({
        id: availability_id
      }).then((response) => {
        this.fetchUnavailabilityItems()
      })
    }
  }
}
</script>
